import { FC } from 'react';
import { FixedTermStatus, IFixedTermItem } from '../types/IFixedTermItem';
import { WarningMessage } from './WarningMessage';
import { TABLE_UNCONFIRMED_FIXED_TERMS_WARNING } from '../constants/data';

type Props = {
  data?: IFixedTermItem[];
};

/**
 * Componente informativo que se muestra cuando hay algún
 * debin sin confirmar.
 * @param data - listado de debines a controlar.
 */

export const UnconfirmedWarning: FC<Props> = ({ data }) => <WarningMessage data={data} checkCondition={checkUnconfirmed} message={TABLE_UNCONFIRMED_FIXED_TERMS_WARNING} />;

const checkUnconfirmed = (item: IFixedTermItem) => {
  return (
    item &&
    (item.status === FixedTermStatus.DEBIN_SIN_AUTORIZAR || item.status === FixedTermStatus.ERROR_PLAZOFIJO) &&
    item.debinId != null &&
    item.debinId.length > 0 &&
    item.expiredDateDebin != null &&
    new Date(item.expiredDateDebin) > new Date()
  );
};
